import { Box, Button, CheckBox, Form, FormField } from "grommet"
import React, { useCallback, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { MainLayout } from "../../components/layout/MainLayout"
import { useNavigate, useParams } from "react-router-dom"
import { useEntryCheckQuery, useJoinByCodeMutation } from "../../generated-types"
import { handleGqlError } from "../../components/utils"
import { useLoginContext } from "../../components/context/LoginContext"
import { PageHeader } from "../dino/components/PageHeader"
import { EmailField } from "./EmailField"

// TODO TextInput 으로 변경 필요

const InputProfile = () => {
  const { code } = useParams()
  const navigate = useNavigate()
  const { login, isLogined } = useLoginContext()
  const { t } = useTranslation()
  const { data, loading, error: entryError } = useEntryCheckQuery({
    variables: { code },
  })

  useEffect(() => {
    if (entryError) {
      handleGqlError(entryError)
      navigate("/login")
    }
  }, [entryError])
  const [joinMutation] = useJoinByCodeMutation({ fetchPolicy: "no-cache" })

  // 외부 임베드 진입 시 자동 주입된 학번(nid). RootRedirector 가 ?nid= 를 sessionStorage 에 보관하며,
  // 직접 /login/:code/profile?nid= 로 진입한 경우도 대비해 쿼리도 함께 확인한다.
  const injectedNid = useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    return params.get("nid") || sessionStorage.getItem("entry_nid") || undefined
  }, [])

  useEffect(() => {
    if (isLogined()) {
      navigate("/my")
    }
  }, [])

  const goNext = useCallback(
    (input) => {
      const { isAgreeEmail, ...profile } = input
      joinMutation({ variables: { code, profile, isAgreeEmail } })
        .then((r) => {
          const { token, username, exp } = r.data.joinByCode
          sessionStorage.removeItem("entry_nid")
          login(username, token, exp)
          navigate("/my", { replace: true })
        })
        .catch(handleGqlError)
    },
    [code]
  )

  return (
    <MainLayout loading={loading}>
      <Box width="medium" align="center" pad="medium">
        <PageHeader
          texts={[
            "STEP 2.",
            data?.entryCheck?.session?.ecodeFields ? t("login.header.enter-profile") : t("login.header.confirm-info"),
            `${t("label.sessName")}: ${data?.entryCheck?.session?.title}`,
          ]}
        />
        {data && (
          <>
            <Box justify="center" width="medium" pad="small">
              <Form onSubmit={(e) => goNext(e.value)}>
                <Box margin={{ top: "medium", bottom: "large" }}>
                  {data?.entryCheck?.session?.ecodeFields?.length > 0 ? (
                    data.entryCheck.session.ecodeFields.map((def, i) => {
                      switch (def.label) {
                        case "accessCode":
                          return (
                            <FormField
                              key={i}
                              name={def.field}
                              style={{ display: "none", borderColor: "#000" }}
                              value={code}
                            />
                          )
                        case "email":
                          return (
                            <Box key={i}>
                              <EmailField {...def} />
                            </Box>
                          )
                        case "isSelf":
                          return (
                            <Box key={i} margin={{ top: "small", bottom: "small" }}>
                              <CheckBox name={def.field} label={t("label.isSelf", { ns: "CHECK", defaultValue: "진단 대상자 본인입니다" })} />
                            </Box>
                          )
                        default:
                          // 외부 임베드로 학번(nid)이 주입된 경우 입력 단계를 숨기고 자동 채움
                          if (def.field === "nid" && injectedNid) {
                            return (
                              <FormField
                                key={i}
                                name={def.field}
                                style={{ display: "none" }}
                                value={injectedNid}
                              />
                            )
                          }
                          return (
                            <FormField
                              key={i}
                              placeholder={t(`label.${def.label}`)}
                              name={def.field}
                              autoCorrect="off"
                              autoCapitalize="off"
                            />
                          )
                      }
                    })
                  ) : (
                    <Box>
                      <EmailField label="email" field="email" />
                    </Box>
                  )}
                </Box>
                <Box direction="row" justify="stretch" gap="small">
                  <Button
                    type="button"
                    label={t("button.back")}
                    fill="horizontal"
                    onClick={() => navigate("/login")}
                    color="#C02026"
                  />
                  <Button type="submit" label={t("button.continue")} primary fill="horizontal" color="#C02026" />
                </Box>
              </Form>
            </Box>
          </>
        )}
      </Box>
    </MainLayout>
  )
}

export default InputProfile
